import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import { ResponseSiiPass } from '../files-clients/interface/company-client.interface';

@Injectable({
  providedIn: 'root',
})
export class PassSiiService {
  constructor(private http: HttpClient) {}

  changeSIIPass(companyRut: string, siiPassword: string): Observable<ResponseSiiPass> {
    const request = {
      companyRut,
      siiPassword,
    };
    console.log(request);
    const endpoint = `${environment.apiUrl}/Company/changePassSII`;
    return this.http.put<ResponseSiiPass>(endpoint, request);
  }
}
